var render = function render(){var _vm=this,_c=_vm._self._c;return _c('portal-target',{attrs:{"name":_vm.model.portal}})
}
var staticRenderFns = []

export { render, staticRenderFns }